var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InputLabel, makeStyles } from "@material-ui/core";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import React, { memo, useRef, useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);
const useClasses = makeStyles((theme) => ({
    root: {
        width: "100%",
        display: "inline-grid",
        gridGap: 4,
        "& .filepond--drop-label > label": theme.typography.subtitle2,
        "& .filepond--root": {
            fontFamily: theme.typography.fontFamily
        },
        "& [data-filepond-item-state*=invalid] .filepond--item-panel": {
            backgroundColor: theme.palette.error.main
        }
    }
}));
const getServerConfig = (folder, baseUrl = "") => ({
    url: `${baseUrl}/api/store/${folder}`,
    process: {
        url: "",
        withCredentials: true
    },
    revert: {
        url: "",
        withCredentials: true
    },
    load: (source, load, cancel) => __awaiter(void 0, void 0, void 0, function* () {
        const request = new Request(source);
        try {
            const response = yield fetch(request);
            const blob = yield response.blob();
            load(blob);
        }
        catch (error) {
            cancel(error);
        }
    })
});
export const FilePicker = memo((props) => {
    var _a;
    const classes = useClasses(props);
    const ref = useRef();
    let backendUrl = "";
    if ((_a = window.config) === null || _a === void 0 ? void 0 : _a.BACKEND_URL) {
        backendUrl = window.config.BACKEND_URL;
    }
    const [files, setFiles] = useState(() => {
        if (props.file) {
            return [
                {
                    source: props.file,
                    options: {
                        type: "local"
                    }
                }
            ];
        }
        return [];
    });
    const update = (files) => {
        setFiles(files.map((file) => file.file));
    };
    const uploaded = (_, file) => {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, file.serverId);
    };
    const removed = () => {
        setTimeout(() => {
            var _a;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, null);
        }, 500);
    };
    return (React.createElement("div", { className: classes.root },
        props.label && React.createElement(InputLabel, { shrink: true }, props.label),
        React.createElement(FilePond, { required: props.required, name: "file", ref: ref, files: files, allowMultiple: false, onupdatefiles: update, onprocessfile: uploaded, onremovefile: removed, onerror: (error, file, status) => console.error(error, file, status), maxFileSize: "250MB", allowImageTransform: true, allowImageCrop: true, allowImagePreview: true, imageCropAspectRatio: "1:1", imageTransformOutputQuality: 65, acceptedFileTypes: props.acceptedFileTypes, server: getServerConfig(props.folder, backendUrl) })));
});
//# sourceMappingURL=FilePicker.js.map